import { Button, Image, Modal } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';

const ProfileUpdateSuccessModal = ({
    show,
    onHide,
    message,
    icon,
    title = 'Update successful',
    bodyContent,
    actions,
    actionLabel = 'OK',
    onAction = onHide,
    backdrop,
}) => {
    const isMobile = useMediaQuery({ query: '(max-width: 767.98px)' });

    if (!isMobile) {
        return (
            <Modal show={show} onHide={onHide} centered backdrop={backdrop}>
                <Modal.Header closeButton><Modal.Title></Modal.Title></Modal.Header>
                <Modal.Body>
                    <Image src={icon} alt="" className="d-block m-auto mb-4" />
                    <h2 className="text-center mb-3">{title}</h2>
                    <p className="text-center">{message}</p>
                    {bodyContent}
                </Modal.Body>
                <Modal.Footer><Button variant="primary" onClick={onHide}>OK</Button></Modal.Footer>
            </Modal>
        );
    }

    return (
        <Modal show={show} onHide={onHide} backdrop={backdrop} className="profile-update-success-mobile-modal"
            dialogClassName="profile-update-success-mobile-dialog"
            contentClassName="profile-update-success-mobile-content"
            aria-labelledby="profile-update-success-mobile-title">
            <Modal.Header closeButton>
                <div className="profile-update-success-mobile-handle" aria-hidden="true" />
                <Modal.Title id="profile-update-success-mobile-title" className="visually-hidden">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Image src={icon} alt="" className="profile-update-success-mobile-icon" />
                <h2>{title}</h2>
                <p>{message}</p>
                {bodyContent}
            </Modal.Body>
            <Modal.Footer className={actions ? 'profile-update-success-mobile-actions' : undefined}>
                {actions || (
                    <Button variant="primary" className="profile-mobile-action-button" onClick={onAction}>{actionLabel}</Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default ProfileUpdateSuccessModal;
